/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'exit-to-app': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" _fill="#050708" d="M19 2.998H5a2 2 0 0 0-2 2v4h2v-4h14v14H5v-4H3v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-14a2 2 0 0 0-2-2zm-8.916 12.586l1.415 1.414 5-5-5-5-1.415 1.414 2.586 2.586H3v2h9.67l-2.586 2.586z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/exit-to-app.js